import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=4b8d1b5e&scoped=true"
import script from "./DictSelect.vue?vue&type=script&lang=js"
export * from "./DictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d1b5e",
  null
  
)

export default component.exports